// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2UM7X","vLegacy":"SelectSecondary_vLegacy__buM3M","error":"SelectSecondary_error__2OCdl","disabled":"SelectSecondary_disabled__2QXMS"};